import { FC, useCallback, useEffect, useState } from "react";
import HighCharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";

import {
  PIE_CHART_OPTIONS,
} from "src/constants/highCharts";
import { wrapperFunctionPieChart, wrapperFunctionPieChartPA } from "src/helpers";
import { pieChartObject } from "./types";
import { topPAPayorsProps, topPayorsMOSECRProps } from "src/pages/manufacturer/types";



const CustomPieChart: FC<pieChartObject> = ({ pieChartObject,title}): JSX.Element => {
  const [data, setData] = useState({});

  const populatePieChart = useCallback(() => {
    const isPATopPayors = title === "Top 10 Payors Requiring PA";

    const topPayorOptions: Highcharts.Options = {
      ...PIE_CHART_OPTIONS,

      plotOptions: isPATopPayors
        ? {
            series: {
              allowPointSelect: true,
              showInLegend: false,
              cursor: "pointer",
              dataLabels: {
                enabled: true,
                useHTML: true,
                formatter: function () {
                  const point = this.point as Highcharts.Point & {
                    precert_pct?: number | string;
                    prior_auth_pct?: number | string;
                    title?: string;
                    percentage?: number;
                  };

                  return `
                    <b>${point.title || point.name}: ${(point.percentage ?? 0).toFixed(1)}%</b><br/>
                    Medical Pre-cert: ${point.precert_pct ?? 0}%<br/>
                    Rx Prior Auth: ${point.prior_auth_pct ?? 0}%
                  `;
                },
              },
            },
          }
        : PIE_CHART_OPTIONS.plotOptions,

      tooltip: isPATopPayors
        ? {
            useHTML: true,
            formatter: function () {
              const point = this.point as Highcharts.Point & {
                pa_count?: number | string;
                percentage?: number | string;
                precert_count?: number | string;
                precert_pct?: number | string;
                prior_auth_pct?: number | string;
                title?: string;
                value?:number
              };

              return `
                <strong>${point.title || point.name}</strong><br/>
                Medical Pre-cert: <strong>${point.precert_count ?? 0}</strong><br/>
                Rx Prior Auth: <strong>${point.pa_count ?? 0}</strong><br/>
                Total Count: <strong>${point.y ?? 0}</strong>
              `;
            },
          }
        : PIE_CHART_OPTIONS.tooltip,

      series: (isPATopPayors
        ? wrapperFunctionPieChartPA(
            pieChartObject as unknown as topPAPayorsProps[]
          )
        : wrapperFunctionPieChart(
            pieChartObject as unknown as topPayorsMOSECRProps[]
          )) as Highcharts.SeriesOptionsType[],
    };

    setData(topPayorOptions);
  }, [pieChartObject, title]);

  useEffect(() => {
    populatePieChart();
  }, [populatePieChart]);

  return (
      <div className="card">
          <div className="card-header">
              <h4 className="m-0">{title}</h4>
          </div>
          <div className="card-body">
              <HighchartsReact highcharts={HighCharts} options={data} />
          </div>
      </div>
  );
};

export default CustomPieChart;



// import { FC, useCallback, useEffect, useState } from "react";
// import HighCharts from "highcharts";
// import HighchartsReact from "highcharts-react-official";
// import drilldown from "highcharts/modules/drilldown";

// import { PIE_CHART_OPTIONS } from "src/constants/highCharts";
// import { pieChartObject } from "./types";

// // Enable drilldown
// if (typeof HighCharts === "object") {
//   drilldown(HighCharts);
// }

// interface ICDChartProps extends pieChartObject {
//   title: string;
// }

// const CustomPieChart: FC<ICDChartProps> = ({ pieChartObject, title }): JSX.Element => {
//   const [options, setOptions] = useState({});

//   const populatePieChart = useCallback(() => {
//     const pieOptions: HighCharts.Options = {
//       ...PIE_CHART_OPTIONS,
//       chart: {
//         type: "pie"
//       },
//       title: { text: title },
//       series: [
//         {
//           type: "pie",
//           name: "ICD Codes",
//           colorByPoint: true,
//           data: pieChartObject.topICDCodes.map((item: any) => ({
//             name: item.icdCode,
//             y: item.value,
//             drilldown: item.icdCode
//           }))
//         }
//       ],
//       drilldown: {
//         series: pieChartObject.topICDCodes.map((item: any) => ({
//           id: item.icdCode,
//           type: "pie",
//           name: `Treatment Areas for ${item.icdCode}`,
//           data: item.treatmentAreas.map((ta: any) => [ta.name, ta.value])
//         }))
//       }
//     };

//     setOptions(pieOptions);
//   }, [pieChartObject, title]);

//   useEffect(() => {
//     populatePieChart();
//   }, [populatePieChart]);

//   return (
//     <div className="card">
//       <div className="card-header">
//         <h4 className="m-0 text-center">{title}</h4>
//       </div>
//       <div className="card-body">
//         <HighchartsReact highcharts={HighCharts} options={options} />
//       </div>
//     </div>
//   );
// };

// export default CustomPieChart;
